export const BRAND = {
  name: "Tricity Kroonerz",
  tagline: "Where Passion Meets the Classics.",
  descriptor: "Live Karaoke Entertainment for Chandigarh & the Tricity",
  phoneDisplay: "95556 07090",
  phone: "+919555607090",
  email: "tricitykroonerz@gmail.com",
  youtube: "https://youtube.com/@tricitykroonerz",
  instagram: "https://www.instagram.com/tricitykroonerz",
  contacts: ["Col. Michael James", "Rajesh Sharma"],
};

export const WA_DEFAULT =
  "Hi Tricity Kroonerz, I'm interested in booking you for an event. I'd like to know more about your performance options.";

export const waLink = (msg = WA_DEFAULT) =>
  `https://wa.me/919555607090?text=${encodeURIComponent(msg)}`;

export const AREAS = ["Chandigarh", "Mohali", "Panchkula", "Zirakpur", "Kharar", "New Chandigarh"];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Performances", href: "#services" },
  { label: "Our Kroonerz", href: "#members" },
  { label: "Concert", href: "#concert" },
  { label: "Videos", href: "#videos" },
  { label: "Gallery", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?crop=entropy&cs=srgb&fm=jpg&q=85",
  vinyl: "https://images.unsplash.com/photo-1789655468334-9aaae6c7cbb8?crop=entropy&cs=srgb&fm=jpg&q=85",
  guitars: "https://images.unsplash.com/photo-1743634426436-e36691c4311d?crop=entropy&cs=srgb&fm=jpg&q=85",
  hall: "https://images.unsplash.com/photo-1780541061419-8742460e6439?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const MEMBERS_DEFAULT = [
  "Col. Michael James",
  "Priyanka Singh",
  "Sushil Nagpal",
  "Rajesh Sharma",
  "Maj. Meenakshi",
  "Salil Mahajan",
  "Priya Marwaha",
  "Vineet Puri",
].map((name) => ({ name, role: "", photo: "" }));

export const FAQS_DEFAULT = [
  { q: "What type of music does Tricity Kroonerz perform?", a: "Primarily Hindi and English retro/classic songs, performed live over karaoke backing tracks. Live band accompaniment can be arranged at an additional cost." },
  { q: "Can we request specific songs?", a: "Yes. You can discuss song requests and genre preferences with the team while planning your performance." },
  { q: "Do you provide your own sound system?", a: "For smaller events, Tricity Kroonerz can provide their own microphones, speakers and amplifiers. Larger events may require additional professional sound, which can be arranged at an additional cost or organised by you." },
  { q: "Can you arrange a live band?", a: "Yes. For events that call for live instrumental accompaniment, a live band can be arranged at an additional cost." },
  { q: "Do you perform at private events?", a: "Yes. Private parties, birthdays, anniversaries and similar family gatherings are among the events Tricity Kroonerz regularly undertakes." },
  { q: "Do you perform at corporate events?", a: "Yes. Tricity Kroonerz performs for corporate gatherings, celebrations and employee events." },
  { q: "Do you perform at restaurants and cafés?", a: "Yes. The group performs karaoke-based live entertainment for restaurants and cafés looking to create a memorable atmosphere." },
  { q: "Do you organize larger concerts?", a: "Yes. Larger-scale concerts can be organized, with sound, refreshments and other production requirements coordinated according to the scale of the event." },
  { q: "How much does a performance cost?", a: "Every event is different. Pricing depends on the number of performers, duration, event size, location, sound and other requirements. Contact Tricity Kroonerz for a customized quotation." },
  { q: "Where do you perform?", a: "Currently across the Chandigarh Tricity: Chandigarh, Mohali, Panchkula, Zirakpur, Kharar and New Chandigarh." },
];

export const EVENT_TYPES = [
  "Private Celebration",
  "Corporate Event",
  "Restaurant / Café",
  "Society / RWA Event",
  "Concert",
  "Senior Citizen Gathering",
  "Other",
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mediaUrl = (src) =>
  src && src.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;
